import React from 'react';
import { Route } from 'react-router';
import Home from '@app/components/presentational/Home';
import { getCurrentUser } from '@core/utils/currentUser';
import {
  getCurrentSpaceId,
  getInitialSpaceId,
} from '@core/selectors/space/space.selectors';
import OverlayLoader from '../components/containers/OverlayLoader';
import UserBar from '../components/presentational/Navigation/UserBarToggle';
import { fetchInitialData, fetchAndSetFeatures } from './Dashboard';
import { getStore } from '../store';
import * as navigationActions from '../actions/navigation';

import withSuspense from '../components/presentational/common/Suspense/Suspense';

const getOnHomeEnter =
  (queryClient, ldClient) => async (nextState, replace) => {
    if (!getCurrentUser()) {
      replace({
        pathname: '/logout',
        state: { nextPathname: nextState.location.pathname },
      });
      return;
    }

    await fetchInitialData(queryClient, ldClient);

    if (!ldClient) return;

    const { dispatch, getState } = getStore();
    const state = getState();
    const currentSpaceId = getCurrentSpaceId(state) || getInitialSpaceId(state);

    if (!currentSpaceId) {
      dispatch(() => fetchAndSetFeatures(state, dispatch, ldClient, undefined));
      return;
    }

    await dispatch(
      navigationActions.decideAndLoadClassRoom(
        currentSpaceId,
        nextState.location.search,
        (spaceId) => fetchAndSetFeatures(state, dispatch, ldClient, spaceId)
      )
    );
  };

const HomeRoute = (queryClient, ldClient) => (
  <Route
    path="home"
    components={{
      overlayLoader: OverlayLoader,
      userBar: UserBar,
      content: withSuspense(Home),
    }}
    onEnter={getOnHomeEnter(queryClient, ldClient)}
  >
    <Route path="*" />
  </Route>
);

export default HomeRoute;
